// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { LogoMark, LogoWordmark } from '@qh/design-tokens/logos';

interface LogoProps {
  variant?: 'mark' | 'wordmark';
  className?: string;
  'aria-hidden'?: boolean;
}

export function Logo({ variant = 'mark', className, 'aria-hidden': ariaHidden }: LogoProps) {
  if (variant === 'wordmark') {
    return <LogoWordmark className={className} aria-hidden={ariaHidden} />;
  }
  return <LogoMark className={className} aria-hidden={ariaHidden} />;
}
